/* import __COLOCATED_TEMPLATE__ from './collection-article.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();